export const getDisplayScore = (score: number) => {
    return score * 10
}
